import { _Types, getServerData } from "@reactivated";

import { getJSONScriptData } from "@thelabnyc/thelabui/src/utils/dom";

export const IS_PUPPETEER =
    typeof window !== "undefined" &&
    window.navigator.userAgent.includes("HeadlessChrome");

export type ReactivatedContext = Readonly<_Types["Context"]>;

export const getReactivatedContext = (): ReactivatedContext | null => {
    if (
        typeof window !== "undefined" &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).__PRELOADED_CONTEXT__
    ) {
        return getServerData().context;
    }
    if (typeof document !== "undefined") {
        return getJSONScriptData(
            "thelabui-react-context",
        ) as ReactivatedContext | null;
    }
    return null;
};
